import { Api } from "../api/Api";
export const userInfo = () => {
  const getUserInfo = async (uuid) => {
    const response = await Api.get("v1/user-info?uuid=" + uuid, {});
    return response;
  };
  return { getUserInfo };
};
